import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { TemplateNodesDict } from 'src/exShared/types/types'
import { containsTableSection, isUnderEmployeeCheckSection } from '.'

/**
 * ドラッグ中のノードが表（またはそれを含むセクション）で、
 * ドロップ先が従業員チェック配下である場合に true を返す。
 * true の場合、呼び出し側はドロップを拒否してエラーダイアログを表示する。
 */
export const shouldBlockTableMoveIntoEmployeeCheck = (
  dragNode: TemplateNodeSchema,
  dropParentNode: TemplateNodeSchema | null,
  allNodes: TemplateNodesDict,
): boolean =>
  containsTableSection(dragNode, allNodes) &&
  isUnderEmployeeCheckSection(dropParentNode, allNodes)
